// Curated Central Coast imagery \u2014 all URLs verified working and on-brand.
// Tonal: warm shadows, muted highlights, film-like \u2014 intended for duotone/vignette use.

const P = (id, w = 1800) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const IMG = {
  // Heroes
  heroHome: P(3895185, 2200), // vineyard at sunset
  heroServices: P(442116, 2200), // vineyard with estate building at golden hour
  heroAbout: P(4070538, 2000), // vineyard dusk with dramatic sky
  heroContact:
    "https://images.unsplash.com/photo-1720300420727-0cc36fdc9d08?auto=format&fit=crop&w=1600&q=80", // coastal fog

  // Supporting editorial images
  vineyardRows: P(442116, 1600),
  vineyardDusk: P(3895185, 1800),
  grapesDusk: P(4070538, 1600),
  estateArch: P(442116, 1800),
  goldenHills: P(3895185, 2200),
  wineStill: P(1407846, 1600), // wine bottle still life
  barrelRoom: P(1407846, 1600),
  coastFog:
    "https://images.unsplash.com/photo-1720300420727-0cc36fdc9d08?auto=format&fit=crop&w=1600&q=80",

  // Team-ish editorial imagery (we use landscape details rather than stock people photos)
  teamA: P(1407846, 1000),
  teamB: P(442116, 1000),
  teamC: P(4070538, 1000),
  teamD: P(3895185, 1000),
};

export const WORK_PLACEHOLDERS = [
  {
    title: "Estate of San Marcos",
    category: "Website \u00b7 Brand System",
    image: P(442116, 1600),
  },
  {
    title: "Harbor & Oak",
    category: "Hospitality \u00b7 Social",
    image:
      "https://images.unsplash.com/photo-1720300420727-0cc36fdc9d08?auto=format&fit=crop&w=1400&q=80",
  },
  {
    title: "Ridge Line Vineyards",
    category: "Website \u00b7 Photography Direction",
    image: P(4070538, 1600),
  },
  {
    title: "The Fog Room",
    category: "Hosting \u00b7 Maintenance",
    image: P(3895185, 1600),
  },
];
